/* global gsap, ScrollTrigger */
(function () {

  function initAnimations() {
    gsap.registerPlugin(ScrollTrigger);
    
    /* .ctm-image-grid — slide in from bottom */
    var imageGrid = document.querySelector('.ctm-image-grid');
    if (imageGrid) {
      gsap.set(imageGrid, { opacity: 0, y: 80 });
      gsap.to(imageGrid, {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: 'power2.out',
        stagger: 0.3,
        scrollTrigger: {
          trigger: imageGrid,
          start: 'top 82%',
          once: true
        }
      });
    }
    /* .ctm-slideinright — each element triggers its own animation */
    document.querySelectorAll('.ctm-slideinright, .additionalinformation .image-block').forEach(function (el) {
      gsap.set(el, { opacity: 0, x: -80 });
      gsap.to(el, {
        opacity: 1,
        x: 0,
        duration: 0.9,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 78%',
          once: true
        }
      });
    });

    /* .ctm-slideinleft — each element triggers its own animation */
    document.querySelectorAll('.ctm-slideinleft, .additionalinformation .caption, .section.section-about-ourstory .image-block, .product-details').forEach(function (el) {
      gsap.set(el, { opacity: 0, x: 80 });
      gsap.to(el, {
        opacity: 1,
        x: 0,
        duration: 0.9,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 78%',
          once: true
        }
      });
    });

    /* .ctm-slideinup — each element triggers its own animation */
    document.querySelectorAll('.ctm-slideinup').forEach(function (el) {
      gsap.set(el, { opacity: 0, y: 80 });
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 82%',
          once: true
        }
      });
    });
    
    /* .ctm-slideindown — each element triggers its own animation */
    document.querySelectorAll('.ctm-slideindown').forEach(function (el) {
      gsap.set(el, { opacity: 0, y: -80 });
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 82%',
          once: true
        }
      });
    });
    
    /* .ctm-editorial-layout .resource-list__item — each triggers its own animation */
    document.querySelectorAll('.ctm-editorial-layout .resource-list__item, .template-page-contact .icons-with-section .icons-with-box, .template-page-contact .contact-form-section .group-block, .cart-page__title, .cart-page__items, .cart-page__summary, facets-form-component, .main-collection-grid').forEach(function (el) {
      gsap.set(el, { opacity: 0, y: 80 });
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 82%',
          once: true
        }
      });
    });
    /* .ctm-slideinup — each element triggers its own animation */
    document.querySelectorAll('media-gallery.media-gallery--grid .media-gallery__grid .product-media-container, .product-video deferred-media, .page-width-content').forEach(function (el) {
      gsap.set(el, { opacity: 0, y: 80 });
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 82%',
          once: true
        }
      });
    });
    
    /* .styleperspectives — hero image slides in from right, caption from bottom */
    var perspImg = document.querySelector('.styleperspectives .hero__media-wrapper img');
    if (perspImg) {
      gsap.set(perspImg, { opacity: 0, x: 80 });
      gsap.to(perspImg, {
        opacity: 1,
        x: 0,
        duration: 0.9,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: '.styleperspectives',
          start: 'top 50%',
          once: true
        }
      });
    }

    var perspCaption = document.querySelector('.styleperspectives .caption');
    if (perspCaption) {
      gsap.set(perspCaption, { opacity: 0, y: 60 });
      gsap.to(perspCaption, {
        opacity: 1,
        y: 0,
        duration: 0.9,
        delay: 0.6,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: '.styleperspectives',
          start: 'top 50%',
          once: true
        }
      });
    }
  }

  /* ─── Mosaic Grid Reveal ──────────────────────────────────────────────── */
  function initMosaicReveal() {
    var grid = document.querySelector('.mosaic-grid');
    if (!grid) return;

    var cards      = grid.querySelectorAll('.mosaic-grid-iteam');
    var centerText = grid.querySelector('.mosaic-grid__center-text');

    if (!cards.length) return;

    var isMobile = window.innerWidth < 750;

    /* Collapsed (before scroll) state */
    var collapsed = [
      {
        x:        "-40%",
        y:        "25%",
      },
      {
        x:        "-80%",
        y:        "50%",
      },
      {
        x:        "40%",
        y:        "-25%",
      },
      {
        x:        "80%",
        y:        "-50%"
      }
    ];

    /* Revealed (after scroll) state — corners of the 1440px canvas
       Left edge: left=30px  → offset from center(720) = 30+150−720 = −540
       Right edge: left=1111px → offset = 1111+150−720 = +541
       Top row: top≈90px, h=342 → y offset = 90+171−483 = −222
       Bottom row: top≈524px   → y offset = 524+171−483 = +212          */
    var revealed = [
      /* card-1: top-left */
      {
        x:        isMobile ? '-110%' : -540,
        y:        isMobile ? '-230%'  : -222
      },
      /* card-2: bottom-left */
      {
        x:        isMobile ? '-110%' : -540,
        y:        isMobile ? '230%'   : 212
      },
      /* card-3: top-right */
      {
        x:        isMobile ? '110%'  : 541,
        y:        isMobile ? '-250%'  : -222
      },
      /* card-4: bottom-right */
      {
        x:        isMobile ? '110%'  : 541,
        y:        isMobile ? '250%'  : 212
      }
    ];

    /* Set initial collapsed state */
    cards.forEach(function (card, i) {
      if (collapsed[i]) {
        var c = /** @type {any} */ (collapsed[i]);
        var props = /** @type {any} */ ({
          x: c.x, y: c.y, rotation: c.rotation,
          scale: c.scale, opacity: c.opacity,
          position: 'absolute', left: '0%', top: '0%'
        });
        if (c.width  != null) { props.width  = c.width;  props.marginLeft = -(c.width  / 2); }
        if (c.height != null) { props.height = c.height; props.marginTop  = -(c.height / 2); }
        gsap.set(card, props);
      }
    });

    if (centerText) {
      gsap.set(centerText, { opacity: 0, position: 'absolute', left: '50%', top: '52%', xPercent: -50, yPercent: -50 });
    }

    /* ScrollTrigger timeline */
    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: grid,
        start: 'top 20%',
        end:   'center center',
        scrub: 1,
        markers: false
      }
    });

    /* Animate each card */
    cards.forEach(function (card, i) {
      if (revealed[i]) {
        tl.to(card, {
          x:        revealed[i].x,
          y:        revealed[i].y,
          rotation: revealed[i].rotation,
          scale:    revealed[i].scale,
          opacity:  revealed[i].opacity,
          duration:  1,
          ease:      'power2.inOut'
        }, 0);
      }
    });

    /* Fade in center text */
    if (centerText) {
      tl.to(centerText, {
        opacity: 1,
        duration: 0.8,
        ease: 'power2.out'
      }, 0.2);
    }
  }

  /* ─── Images Row Grid Reveal ────────────────────────────────────────────── */
  function initImagesRowGridReveal() {
    var grid = document.querySelector('body.template-page-editorial .editorial-section-01 .images-row-grid');
    if (!grid) return;

    var blocks = grid.querySelectorAll('.image-block');
    if (!blocks.length) return;

    var isTablet = window.innerWidth < 990;

    /* Collapsed (before scroll) — all blocks start near center */
    var collapsed = [
      { x:  80, y: 0 },
      { x:  40, y: 0 },
      { x: -40, y: 0 },
      { x: -80, y: 0 }
    ];

    /* Revealed (after scroll) — matches CSS final positions.
       Items 3 and 4 carry the CSS transform offsets baked in. */
    var revealed = [
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0,    y: isTablet ? 0 : '20%'  },
      { x: isTablet ? 0 : '-60%', y: isTablet ? 0 : '-10%' }
    ];

    blocks.forEach(function (block, i) {
      if (collapsed[i]) {
        gsap.set(block, { x: collapsed[i].x, y: collapsed[i].y, opacity: 0 });
      }
    });

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: grid,
        start: 'top 70%',
        end:   'center 50%',
        scrub: 1,
        markers: false
      }
    });

    blocks.forEach(function (block, i) {
      if (revealed[i]) {
        tl.to(block, {
          x:        revealed[i].x,
          y:        revealed[i].y,
          opacity:  1,
          duration: 1,
          ease:     'power2.inOut'
        }, 0);
      }
    });

    /* Heading and text blocks — scrub in from opposite sides */
    var section = grid.closest('.editorial-section-01');
    if (section) {
      var headingBlock = section.querySelector('.ctm-heading-block');
      var textBlock    = section.querySelector('.ctm-text-block');

      if (headingBlock) {
        gsap.fromTo(headingBlock,
          { opacity: 0, x: -60 },
          {
            opacity: 1,
            x: 0,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: headingBlock,
              start: 'top 85%',
              end:   'top 40%',
              scrub: 1
            }
          }
        );
      }

      if (textBlock) {
        gsap.fromTo(textBlock,
          { opacity: 0, x: 60 },
          {
            opacity: 1,
            x: 0,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: textBlock,
              start: 'top 85%',
              end:   'top 40%',
              scrub: 1
            }
          }
        );
      }
    }
  }

  /* ─── Editorial Section 02 Reveal ──────────────────────────────────────── */
  function initEditorialSection02Reveal() {
    var section = document.querySelector('body.template-page-editorial .editorial-section-02');
    if (!section) return;

    var titleBlock = section.querySelector('.main-title-block');
    var imageGroup = section.querySelector('.image-gorup');
    var caption    = section.querySelector('.caption');

    /* Title — fade up from bottom */
    if (titleBlock) {
      gsap.fromTo(titleBlock,
        { opacity: 0, y: 60 },
        {
          opacity: 1, y: 0,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: titleBlock,
            start: 'top 85%',
            end:   'top 45%',
            scrub: 1
          }
        }
      );
    }

    /* Image blocks inside .image-gorup */
    if (imageGroup) {
      var img1 = imageGroup.querySelector('.image-block:nth-of-type(1)');
      var img2 = imageGroup.querySelector('.image-block:nth-of-type(2)');

      if (img1) {
        gsap.fromTo(img1,
          { opacity: 0, x: -80, y: 40 },
          {
            opacity: 1, x: 0, y: 0,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: imageGroup,
              start: 'top 80%',
              end:   'center 50%',
              scrub: 1
            }
          }
        );
      }

      if (img2) {
        gsap.fromTo(img2,
          { opacity: 0, x: 80 },
          {
            opacity: 1, x: 0,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: imageGroup,
              start: 'top 80%',
              end:   'center 50%',
              scrub: 1
            }
          }
        );
      }
    }

    /* Caption — fade up */
    if (caption) {
      gsap.fromTo(caption,
        { opacity: 0, y: 50 },
        {
          opacity: 1, y: 0,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: caption,
            start: 'top 85%',
            end:   'top 45%',
            scrub: 1
          }
        }
      );
    }
  }

  /* ─── Stay Connected parallax ───────────────────────────────────────────── */
  function initStayConnected() {
    var cols = gsap.utils.toArray('.stay-connected .col');
    if (!cols.length) return;

    var mm = gsap.matchMedia();

    /* Desktop (≥990px): section pins, columns scroll in opposite directions */
    mm.add('(min-width: 990px) and (prefers-reduced-motion: no-preference)', function () {
      var section = document.querySelector('.stay-connected');
      if (!section) return;

      var overflowOf = function (col) {
        return Math.max(0, col.offsetHeight - section.clientHeight + 140);
      };

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top top',
          end: function () { return '+=' + window.innerHeight * 1.4; },
          pin: true,
          scrub: 1,
          anticipatePin: 1,
          invalidateOnRefresh: true
        }
      });

      cols.forEach(function (col, i) {
        if (i % 2 === 0) {
          tl.fromTo(col, { y: 0 }, { y: function () { return -overflowOf(col); }, ease: 'none' }, 0);
        } else {
          tl.fromTo(col, { y: function () { return -overflowOf(col); } }, { y: 0, ease: 'none' }, 0);
        }
      });

      gsap.from('.stay-connected .stay-connected-header-text', {
        autoAlpha: 0,
        y: 24,
        duration: 1,
        ease: 'power2.out'
      });
    });

    /* Mobile (≤989px): gallery pins, rows scroll horizontally in opposite directions */
    mm.add('(max-width: 989px) and (prefers-reduced-motion: no-preference)', function () {
      var gallery = document.querySelector('.stay-connected .gallery');
      if (!gallery) return;

      var overflowOf = function (col) {
        return Math.max(0, col.scrollWidth - col.clientWidth + 50);
      };

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: gallery,
          start: 'top bottom',
          end: function () { return '+=' + window.innerHeight * 1.4; },
          scrub: 1,
          anticipatePin: 1,
          invalidateOnRefresh: true
        }
      });

      cols.forEach(function (col, i) {
        if (i % 2 === 0) {
          tl.fromTo(col, { x: function () { return -overflowOf(col); } }, { x: 0, ease: 'none' }, 0);
        } else {
          tl.fromTo(col, { x: 0 }, { x: function () { return -overflowOf(col); }, ease: 'none' }, 0);
        }
      });

      gsap.from('.stay-connected .stay-connected-header-text', {
        autoAlpha: 0,
        y: 20,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: { trigger: '.stay-connected .stay-connected-header', start: 'top 85%' }
      });
    });
  }

  /* Poll until both gsap and ScrollTrigger are available, then run once.
     Gives up after 5 s so pages without GSAP don't loop indefinitely. */
  var gsapPollCount = 0;
  function waitForGsap() {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      initAnimations();
      initMosaicReveal();
      initImagesRowGridReveal();
      initEditorialSection02Reveal();
      initStayConnected();
    } else if (gsapPollCount < 100) {
      gsapPollCount++;
      setTimeout(waitForGsap, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForGsap);
  } else {
    waitForGsap();
  }

})();